<template>
  <!-- 会话列表 -->
  <ul>
    <li class="d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover" v-for="item in sessions" :key="item.id" :class="{'bg-g-100':item.id===toAccount}" @click="itemClickEvent(item)" :ref="item.id+'Ref'">
      <div class="d-table-cell v-a-middle h-100-p w-64" v-if="item.scene==='p2p'" style="text-align: center;">
        <span v-if="item.to.length==32&&(item.to!=$store.state.user.loginId)" class="d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none" style="background-color: #653EB3;">
        {{
          getShortNickname(item.userInfo.nickName?item.userInfo.nickName:item.userInfo.mobile?item.userInfo.mobile:item.userInfo.userName?item.userInfo.userName:item.userInfo.tel)
          }}
        </span>
        <img  v-else-if="item.to.length!=32&&(item.to!=$store.state.user.loginId)" src="@/assets/images/im/kefu.svg" style="width:40px;height:40px;"/>
        <img  v-else-if="item.to==$store.state.user.loginId" src="@/assets/images/im/laba.png" style="width:40px;height:40px;"/>
      </div>
      <div class="d-table-cell v-a-middle h-100-p w-64" v-if="item.scene==='team' && item.userInfo.serverCustom" style="text-align: center;">
        <img v-if="item.userInfo.avatar" :src="item.userInfo.avatar" style="width:40px;height:40px;"/>
        <img v-else src="@/assets/images/im/zhuanShu@2x.png" style="width:40px;height:40px;"/>
      </div>
      <div class="d-table-cell v-a-middle h-100-p w-64 t-a-center" v-if="item.scene==='team' && !item.userInfo.serverCustom">
      <img src="@/assets/images/im/team-cus.png" style="width:40px;height:40px;"/>
      </div>
      <div class="p-relative d-table-cell v-a-middle h-100-p">
        <div :style="{width:listWidth+'px'}">
          <!-- 单聊 -->
          <div v-if="item.scene==='p2p'">
            <p class="t-ellipsis l-h-1-6-em m-r-10" :data-type="JSON.stringify(item)" v-if="item.to.length==32&&(item.to!=$store.state.user.loginId)">{{item.userInfo.nickName?item.userInfo.nickName:item.userInfo.mobile?item.userInfo.mobile:item.userInfo.userName?item.userInfo.userName:item.userInfo.tel}}</p>
            <p class="t-ellipsis l-h-1-6-em m-r-10" v-else-if="item.to.length!=32&&(item.to!=$store.state.user.loginId)">{{item.userInfo.userName||''}}<span v-show="item.userInfo.userName">{{item.userInfo.stationName?'-'+item.userInfo.stationName:''}}</span>
            <p class="t-ellipsis l-h-1-6-em m-r-10" :data-type="JSON.stringify(item)" v-if="item.to==$store.state.user.loginId">群通知</p>
            <span v-show="!item.userInfo.userName&&!item.userInfo.stationName">{{item.userInfo.userCode}}</span></p>
            <!-- 草稿 -->
            <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-400 flex" v-if="item.id != toAccount && item.abstract" v-html="item.abstract"></p>
            <!-- 最后一条消息 -->
            <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-400" v-else>{{lastMsgCp(item)}}</p>
            
          </div>
          <!-- 群聊 -->
          <div v-if="item.scene==='team'">
            <p class="t-ellipsis l-h-1-6-em m-r-10">{{item.userInfo.name}}</p>
            <!-- 草稿 -->
            <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-400 flex"  v-if="item.id != toAccount && item.abstract" v-html="item.abstract"></p>
            <!-- 最后一条消息 -->
            <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-400" v-else><span style="color:#fb1010;" v-show="item.appointText">{{removal(item.appointText)}}</span>{{lastMsgCp(item)}}</p>
          </div>
          <img  class="mute-logo" v-if="item.muteNotiType==1" src="@/assets/images/im/mute.png"/>
          <img  class="top-logo" v-if="item.istop" src="@/assets/images/im/istop.png"/>
          <span class="p-absolute right-6 bottom-32 p-x-5 f-s-12 l-h-1-4-em c-white" :style="{'background-color': '#f33232','border-radius': '10px','font-size': item.muteNotiType==1?'10px':'12px'}" v-if="item.unread>0">{{item.muteNotiType==1?'&nbsp;':item.unread}}</span>
        </div>
      </div>
      <im-context-menu :target-parent-ref="$refs" :target-ref-name="item.id+'Ref'" :ref="item.id+'ContextRef'">
        <div class="p-absolute z-index-1 m-l-10 bg-white b b-c-g-100 r-4 shadow-3-g-100" style="width:120px">
          <!-- 单聊 -->
          <div v-if="item.scene==='p2p'">
          <!-- <p class="p-x-10 p-y-6 b-b b-c-g-100 cursor-pointer bg-g-50-hover" @click="itemInfoHandler(item)">个人信息</p> -->
            <p class="p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover" @click="addStickTopSession(item)">{{item.istop?'取消置顶':'置顶会话'}}</p>
            <p class="p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover" @click="markInMutelist(item)">{{item.muteNotiType==1?'开启消息提醒':'消息免打扰'}}</p>
            <p class="p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover" @click="deleteLocalSession(item)">移除会话</p>
            <!--<p class="p-x-10 p-y-6 m-b-8 b-c-g-100 cursor-pointer bg-g-50-hover" @click="deleteLocalMsgsBySession(item)">清空聊天记录</p>-->
          </div>
          <!-- 群聊 -->
          <div v-if="item.scene==='team'">
          <!--<p class="p-x-10 p-y-6 b-b b-c-g-100 cursor-pointer bg-g-50-hover" @click="teamConfig(item)">群设置</p>-->
            <p class="p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover" @click="addStickTopSession(item)">{{item.istop?'取消置顶':'置顶会话'}}</p>
            <p class="p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover" @click="updateInfoInTeamMuteTeam(item)">{{item.muteNotiType==1?'开启消息提醒':'消息免打扰'}}</p>
            <p class="p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover" @click="deleteLocalSession(item)">移除会话</p>
            <!--<p class="p-x-10 p-y-6 m-b-8 cursor-pointer bg-g-50-hover" @click="deleteLocalMsgsBySession(item)">清空聊天记录</p>-->
          </div>
        </div>
      </im-context-menu>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    sessions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    toAccount: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 250
    },
    im: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  data: function () {
    return {
      listWidth: 185,
      eventProxy: {
        event: null,
        currentTarget: null
      },
      groupId:'',
    };
  },
  components: {
    'im-context-menu': () => import('./component/im-context-menu.vue'),
    'im-popover': () => import('./component/im-popover.vue')
  },
  mounted: function () {
    let vm = this;
    this.bus.$on("selectNewChatRoom",(teamId)=>{
      //后期优化  onUpdateSession执行后再进行一下操作
      setTimeout(()=>{
        // console.log("vm.sessions",vm.sessions)
        let clickItem = vm.sessions.filter(item=>{
          return item.id == teamId
        });
        clickItem.length && vm.itemClickEvent(clickItem[0])
      },100)
    })
  },
  methods: {
    
    //会话置顶
    addStickTopSession(item){
      let login = this.$store.state.user.loginId;
      let topList = localStorage.getItem(login+'istop');
      if(item.istop){
        if(topList&&topList.length){
          topList = JSON.parse(topList);
          topList.forEach((element,index)=>{
            if(element==item.id){
              topList.splice(index,1)
            }
          })

          localStorage.setItem(login+'istop',JSON.stringify(topList));
          if(topList.length==0){
            this.$refs[item.id+'Ref'][0].click();
          }
        }else{
          localStorage.setItem(login+'istop',JSON.stringify([]));
        }
        item.istop = false;
        console.log('itemistop',item.istop)
      }else{
        if(topList&&topList.length){
            topList = JSON.parse(topList);
            topList.unshift(item.id);
            topList = [...new Set(topList)];
            localStorage.setItem(login+'istop',JSON.stringify(topList));
          }else{
            localStorage.setItem(login+'istop',JSON.stringify([item.id]));
          }
          item.istop = true;
        
        
      }
      this.$emit("updatesessions");
      this.$refs[item.id + 'ContextRef'][0].destroy();
      // this.im.addStickTopSession({
      //   id:item.id,//要置顶的会话ID
      //   topCustom:'',
      //   done:(error,res)=>{
      //     console.log(error,res)
      //   }
      // })
    },
    //取消会话置顶
    deleteStickTopSession(item){
      let login = this.$store.state.user.loginId;
      let topList = localStorage.getItem(login+'istop');
      if(topList&&topList.length){
        topList = JSON.parse(topList);
        topList.forEach((element,index)=>{
          if(element==item.id){
            topList.splice(index,1)
          }
        })
        
        localStorage.setItem(login+'istop',JSON.stringify(topList));
      }else{
        localStorage.setItem(login+'istop',JSON.stringify([]));
      }
      this.$refs[item.id + 'ContextRef'][0].destroy();
      // this.im.deleteStickTopSession({
      //   id:item.id,//取消置顶的会话ID
      //   done:(error,res)=>{
      //     console.log(error,res)
      //   }
      // })
    },
    //单聊静音
    markInMutelist(item){
      console.log('item',item)
       this.im.markInMutelist({
         account:item.to,
         isAdd:item.muteNotiType=='1'?false:true,
         done:(error,res)=>{
           if(error){
             this.$message.error(error);
          }else{
            this.$set(item,'muteNotiType',+res.isAdd)
            this.$refs[item.id + 'ContextRef'][0].destroy();
            // this.$emit('updatesessions',item);
          }
           
         }
       })
    },
    //群聊静音
    updateInfoInTeamMuteTeam(item){
      this.im.updateInfoInTeam({
        teamId:item.to,
        muteNotiType:item.muteNotiType=='1'?0:1,
        done:(error,obj)=>{
          if(error){
             this.$message.error(error);
          }else{
            // this.$message({
            //   message:'设置成功',
            //   type: 'success'
            // });
            this.$set(item,'muteNotiType',obj.muteNotiType)
            this.$refs[item.id + 'ContextRef'][0].destroy();
            // this.$emit('updatesessions',item);
          }
        }
      })
    },
    // 去重
    removal: function (data) {
      if(data){
        var arrStr = data.split(" ");
        var newArr = Array.from(new Set(arrStr));
        return newArr.join(" ");
      }
    },
    // 截取名称后俩位
    getShortNickname: function (name) {
      name = name || '';
      var len = name.length;
      return name.slice(len - 2, len);
    },
    getShortGroupname: function (name) {
      name = name || '';
      return name.slice(0, 2);
    },
    // 个人信息
    itemInfoHandler: function (item) {
      this.$refs[item.id + 'ContextRef'][0].destroy();
      var $this = this;
      setTimeout(function () {
        $this.$refs[item.id + 'ItemInfoRef'][0].open($this.eventProxy.event, $this.eventProxy.currentTarget);
      }, 0);
    },
    // 点击联系人
    itemClickEvent: function (item) {
      if(document.getElementById("edit-content")){
        this.creatDraftAbstract();
      }
      document.querySelector('#imLayout').click();
      if(item.replyInfo) {
        document.getElementById('msgContentRef').style.height = `calc(100% - ${item.replyInfo.offsetHeight})`;
      } else {
        document.getElementById('msgContentRef').style.height = '100%';
      }
      this.$parent.contactItemClickEvent(item)
    },
    //草稿摘要
    creatDraftAbstract(){
      let abstractHtml = document.getElementById("edit-content").innerHTML,
        children = Array.from(document.getElementById("edit-content").children),
        vm = this,session;
      session = this.sessions.filter(item=>{
        return item.id == vm.toAccount
      })[0];
      if(!abstractHtml && !session){
        return
      }
      children.map(item=>{
        if(item.getAttribute('data-type') == "file" && item.innerText){
          abstractHtml = abstractHtml.replace(item.outerHTML,"<span>[文件]</span>");
        }else if(item.getAttribute('data-type') == "file" && !item.innerText){//解决删除时留下的空dom
          abstractHtml = abstractHtml.replace(item.outerHTML,"");
        }else if(item.getAttribute('data-type') == "insertImage"){
          abstractHtml = abstractHtml.replace(item.outerHTML,"<span>[图片]</span>");
        }else if(item.nodeName == "BR"){
          abstractHtml = abstractHtml.replace(item.outerHTML,"");
        }
      })
      abstractHtml = abstractHtml? '<span style="color:#fb1010">[草稿]</span>'+abstractHtml:abstractHtml;
      session.abstract = abstractHtml;
    },
    // 移除会话
    deleteLocalSession: function (item) {
      this.$refs[item.id + 'ContextRef'][0].destroy();
      this.$emit('deleteLocalSession', item);
    },
    //置顶会话
    // addStickTopSession(item){
    //   this.$refs[item.id + 'ContextRef'][0].destroy();
    //   this.$emit("addStickTopSession",item)
    // },
    // 删除聊天记录
    deleteLocalMsgsBySession: function (item) {
      this.$refs[item.id + 'ContextRef'][0].destroy();
      this.$emit('deleteLocalMsgsBySession', item);
    },
    // 群设置
    teamConfig: function (item) {
      this.$refs[item.id + 'ContextRef'][0].destroy();
      this.$emit('clickEmit', item);
      this.$emit('teamConfig', item);
    },
    // 销毁个人信息
    itemContextmenuEvent: function (event) {
      this.eventProxy.event = event;
      this.eventProxy.currentTarget = event.currentTarget;
      for (var i = 0; i < this.sessions.length; i++) {
        var session = this.sessions[i];
        if (session.scene === 'p2p') {
          this.$refs[session.id + 'ItemInfoRef'] && this.$refs[session.id + 'ItemInfoRef'][0].destroy();
        }
      }
    },
  },
  watch: {
    width: function (val) {
      console.log("val",val);
      this.listWidth = val - 65;
    }
  },
  computed: {
    // 动态设置最后一条消息
    lastMsgCp: function () {
      return function (item) {
        var len = item.chatRecordStore.length - 1;
        var lastMsg = item.chatRecordStore[len];
        if (!lastMsg || lastMsg.errorCodeExpand === 404) return '';
        if (lastMsg.type === 'text') {
          var str = lastMsg.text ? lastMsg.text : '';
          str = str.replace(/(<br>)|(&nbsp;)/g, ' ');
          str = str.replace(/<span[^>.]+>/g, ' ');
          str = str.replace(/<\/span>/g, ' ');
          return str;
        } else if (lastMsg.type === 'image') {
          return '[图片]';
        } else if(lastMsg.type === 'custom') {
          let msgObj = JSON.parse(lastMsg.content);
          return msgObj.data.msgContent
        } else if(lastMsg.type === 'file') {
          return '[文件]'
        } else if(lastMsg.type === 'video') {
          return '[视频]'
        }
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.mute-logo{
  width: 20px;
  height: 20px;
  position: absolute;
  top: 16px;
  right: 5px;
}
.top-logo{
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0px;
  right: 0px;
}
</style>
